module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray pb-navs"
  }, [_c('backTitleBar', {
    attrs: {
      "rightEle": _vm.rightEle
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "home-main"
  }, [_c('div', {
    staticClass: "flex-center"
  }, [_c('div', {
    staticClass: "flex1"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.entity.shopName))]), _vm._v(" "), _c('div', {
    staticClass: "color-999 fs-28"
  }, [_vm._v(_vm._s(_vm.entity.address))])]), _vm._v(" "), _c('div', {
    staticClass: "right-time text-center click",
    on: {
      "click": _vm.openPicker
    }
  }, [_c('div', {
    staticClass: "alifont icon-bianzu color-999",
    staticStyle: {
      "font-size": ".4rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999"
  }, [_vm._v(_vm._s(_vm.showDateValue))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-30"
  }, [_c('span', {
    staticClass: "color-999 fs-28"
  }, [_vm._v("销量金额")]), _vm._v(" "), _c('span', {
    staticClass: "ml-10 number_font money"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.salesCount || 0)))]), _vm._v(" "), _c('span', {
    staticClass: "color-999 fs-28",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_vm._v("柜内货价")]), _vm._v(" "), _c('span', {
    staticClass: "ml-10 number_font money"
  }, [_vm._v(_vm._s(_vm.formatNumber(Number(_vm.countEntity.stockAmount || 0).toFixed(2))))])])]), _vm._v(" "), _c('div', {
    staticClass: "card number-count"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "left flex1 "
  }, [_c('div', {
    staticClass: "f1 number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.openDoorCount || 0)))]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999"
  }, [_vm._v("开门次数")])]), _vm._v(" "), _c('div', {
    staticClass: "right flex1"
  }, [_c('div', {
    staticClass: "f1 number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.buyUserCount || 0)))]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999"
  }, [_vm._v("购买用户数")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex mt-25"
  }, [_c('div', {
    staticClass: "left flex1"
  }, [_c('div', {
    staticClass: "f1 number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.orderCount || 0)))]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999"
  }, [_vm._v("订单数")])]), _vm._v(" "), _c('div', {
    staticClass: "right flex1"
  }, [_c('div', {
    staticClass: "f1 number_font"
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.countEntity.itemCount || 0)))]), _vm._v(" "), _c('div', {
    staticClass: "fs-28 color-999"
  }, [_vm._v("商品销售数")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin-top": "-.8rem"
    }
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("\n            商品销售榜\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "card-tab"
  }, _vm._l((_vm.tabList), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "tab-item",
      class: _vm.tabActive == item.value ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.tabActive = item.value
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabActive == 1),
      expression: "tabActive == 1"
    }]
  }, [_vm._m(0), _vm._v(" "), _c('ul', _vm._l((_vm.saleList), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "li-item"
    }, [_c('div', {
      staticClass: "table-index"
    }, [_vm._v(_vm._s($index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "table-main"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "table-number"
    }, [(item.isWeightCalc != 1) ? _c('span', [_vm._v(_vm._s(item.quantity))]) : _vm._e(), _vm._v(" "), (item.isWeightCalc == 1) ? _c('span', [_vm._v(_vm._s(item.quantity / 1000) + "kg")]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabActive == 2),
      expression: "tabActive == 2"
    }]
  }, [_vm._m(1), _vm._v(" "), _c('ul', _vm._l((_vm.amountList), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "li-item"
    }, [_c('div', {
      staticClass: "table-index"
    }, [_vm._v(_vm._s($index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "table-main"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "table-number"
    }, [_vm._v(_vm._s(Number(item.salesAmount || 0).toFixed(2)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "margin": ".2rem .25rem"
    }
  }, [_c('div', {
    staticClass: "card-title"
  }, [_vm._v("商品销售统计")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', _vm._l((_vm.stockList), function(item, $index) {
    return _c('li', {
      key: $index,
      staticClass: "li-item"
    }, [_c('div', {
      staticClass: "table-index"
    }, [_vm._v(_vm._s($index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "table-main"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "table-number2"
    }, [(item.isWeightCalc != 1) ? _c('span', [_vm._v(_vm._s(item.num))]) : _vm._e(), _vm._v(" "), (item.isWeightCalc == 1) ? _c('span', [_vm._v(_vm._s(item.num / 1000) + "kg")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "table-number2"
    }, [(item.isWeightCalc != 1) ? _c('span', [_vm._v(_vm._s(item.saleNum || 0))]) : _vm._e(), _vm._v(" "), (item.isWeightCalc == 1) ? _c('span', [_vm._v(_vm._s((item.saleNum || 0) / 1000) + "kg")]) : _vm._e()])])
  }), 0)]), _vm._v(" "), _c('navs', {
    attrs: {
      "shopId": _vm.shopId
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.popupShow),
      callback: function($$v) {
        _vm.popupShow = $$v
      },
      expression: "popupShow"
    }
  }, [_c('van-datetime-picker', {
    attrs: {
      "type": "date"
    },
    on: {
      "confirm": _vm.handleConfirm,
      "cancel": _vm.handleCancel
    },
    model: {
      value: (_vm.selectValue),
      callback: function($$v) {
        _vm.selectValue = $$v
      },
      expression: "selectValue"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-table-header"
  }, [_c('div', {
    staticClass: "table-index"
  }, [_vm._v("排行")]), _vm._v(" "), _c('div', {
    staticClass: "table-main"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('div', {
    staticClass: "table-number"
  }, [_vm._v("数量")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-table-header"
  }, [_c('div', {
    staticClass: "table-index"
  }, [_vm._v("排行")]), _vm._v(" "), _c('div', {
    staticClass: "table-main"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('div', {
    staticClass: "table-number"
  }, [_vm._v("金额")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-table-header"
  }, [_c('div', {
    staticClass: "table-index"
  }, [_vm._v("排行")]), _vm._v(" "), _c('div', {
    staticClass: "table-main"
  }, [_vm._v("商品名称")]), _vm._v(" "), _c('div', {
    staticClass: "table-number2"
  }, [_vm._v("库存")]), _vm._v(" "), _c('div', {
    staticClass: "table-number2"
  }, [_vm._v("销量")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f21f89fa","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/equipment/equipmentHome.vue
// module id = Fl9y
// module chunks = 51